import axios from "axios";
import ACTIONS from "./types";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";

export const GetAllOrganizations = () => dispatch => {
  axios
    .get(`${API_ENDPOINTS.ORGANIZATIONS}`)
    .then(res => {
      if (res.data.length === 0) return;
      dispatch({
        type: ACTIONS.TRENDS.GET_ALL_ORGNANIZATION,
        payload: [...res.data]
      });
    })
    .catch(err => {
      dispatch({
        type: ACTIONS.ORGANIZATIONS.FETCH_ALL_ORGANIZATIONS_LIST_FAILURE,
        payload: err
      });
    });
};

export const setSelectedOrganization = selectedOrganization => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SET_SELECTED_ORGNANIZATION,
    payload: selectedOrganization
  });
};

export const AnalyticsTrendsOrgGroups = selectedOrganization => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.CLEAR_GROUPS_LIST
  });
  axios.get(API_ENDPOINTS.ANALYTICS_TRENDS_ORG_GROUPS.replace("{organizations_id}", selectedOrganization._id)).then(res => {
    if (res.data.hasOwnProperty("groups") && res.data.groups.length > 0)
      dispatch({
        type: ACTIONS.TRENDS.GET_ORGANIZATION_GROUPS,
        payload: res.data.groups
      });
    else
      dispatch({
        type: ACTIONS.TRENDS.SELECTED_ORGANIZATION_HAS_NO_GROUPS
      });
  });
};

export const AnalyticsServiceSchedulesOrgGroups = selectedOrganization => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.CLEAR_GROUPS_LIST
  });
  axios.get(API_ENDPOINTS.ANALYTICS_SERVICE_SCHEDULES_ORG_GROUPS.replace("{organizations_id}", selectedOrganization._id)).then(res => {
    if (res.data.hasOwnProperty("groups") && res.data.groups.length > 0)
      dispatch({
        type: ACTIONS.TRENDS.GET_ORGANIZATION_GROUPS,
        payload: res.data.groups
      });
    else
      dispatch({
        type: ACTIONS.TRENDS.SELECTED_ORGANIZATION_HAS_NO_GROUPS
      });
  });
};

export const setIsFetchingGroups = flag => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.START_FETCHING_GROUPS,
    pyload: flag
  });
};
export const setcurrntActiveMode = currntActiveMode => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SET_CURRENT_ACTIVE_MODE,
    pyload: currntActiveMode
  });
};

export const GetConstAnalyticsRefs = () => dispatch => {
  axios
    .get(`${API_ENDPOINTS.CONST_ANALYTICS_REFS}`)
    .then(res => {
      if (res.data.length === 0) return;
      // res.data.forEach(ref => {
      //   ref.label = ref.title;
      // });
      dispatch({
        type: ACTIONS.TRENDS.SET_REF_LIST,
        payload: [...res.data]
      });
    })
    .catch(err => {
      console.log("TRENDS.SET_PERIOD_LIST", err);
    });
};
export const GetConstAnalyticsPeriods = () => dispatch => {
  axios
    .get(`${API_ENDPOINTS.CONST_ANALYTICS_PERIODS}`)
    .then(res => {
      if (res.data.length === 0) return;
      // res.data.forEach(ref => {
      //   ref.label = ref.title;
      // });
      dispatch({
        type: ACTIONS.TRENDS.SET_PERIOD_LIST,
        payload: [...res.data]
      });
    })
    .catch(err => {
      console.log("TRENDS.SET_PERIOD_LIST", err);
    });
};

export const SetSelectedGroup = _selectedGroup => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SELECTED_GROUP,
    payload: _selectedGroup
  });
};
export const SetSelectedRef = _selectedRef => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SELECTED_REF,
    payload: _selectedRef
  });
};
export const SetSelectedPeriod = _selectedPeriod => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SELECTED_PERIOD,
    payload: _selectedPeriod
  });
};
export const SetSelectedDate = _selectedDate => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SELECTED_DATE,
    payload: _selectedDate
  });
};

export const ChangeCurrntActiveMode = activeTabName => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.SET_SELECTED_CURRENT_ACTIVE_MODE,
    payload: activeTabName
  });
};

const setOpenDevicesToReloadMode = orgGroups => {
  let _groups = [];
  orgGroups.forEach(group => {
    let _devices = [];
    group.devices.forEach(device => {
      _devices.push(device.hasOwnProperty("isFetchingData") && !device.isFetchingData ? { ...device, isFetchingData: true } : { ...device });
    });
    if (_devices.length > 0) _groups.push({ ...group, devices: _devices });
  });
  return _groups;
};
export const _UpdateAllTrendsDevicesData = (
  orgGroups,
  selectedRef,
  selectedDate,
  selectedPeriod,
  selectedOrganization,
  devicesWithDetailsList,
  currntActiveMode
) => dispatch => {
  const _groups = setOpenDevicesToReloadMode(orgGroups);

  dispatch({
    type: ACTIONS.TRENDS.SET_ALL_TRENDS_DEVICES_TO_FETCH,
    payload: _groups
  });

  let _reqsList = [];
  let _orgGroups = [..._groups];
  orgGroups.forEach((group, Gindex) => {
    group.devices.forEach((device, Dindex) => {
      if (devicesWithDetailsList.find(od => od._id === device._id)) {
        switch (currntActiveMode) {
          case "DataAnalytics":
            _reqsList.push(
              axios.get(
                API_ENDPOINTS.ANALYTICS_TRENDS.replace("{orgId}", selectedOrganization._id)
                  .replace("{groupId}", group._id)
                  .replace("{deviceId}", device.device)
                  .replace("{ref}", selectedRef.value)
                  .replace("{period}", selectedPeriod.value)
                  .replace("{date}", selectedDate)
              )
            );
            break;
          case "Scheduling":
            _reqsList.push(
              axios.get(
                API_ENDPOINTS.ANALYTICS_SERVICE_SCHEDULES.replace("{orgId}", selectedOrganization._id)
                  .replace("{groupId}", group._id)
                  .replace("{deviceId}", device.device)
                  .replace("{period}", selectedPeriod.value)
                  .replace("{date}", selectedDate)
              )
            );

            break;
          default:
            break;
        }
      }
    });
  });

  Promise.all([..._reqsList]).then(values => {
    orgGroups.forEach((group, Gindex) => {
      group.devices.forEach((device, Dindex) => {
        values.forEach((value, vindex) => {
          if (value.data._id === device._id) {
            _orgGroups[Gindex].devices[Dindex] = { ...device, ...value.data, isFetchingData: false };
          }
        });
      });
    });
    dispatch({
      type: ACTIONS.TRENDS.SET_ALL_TRENDS_DEVICES_TO_FETCH,
      payload: _orgGroups
    });
  });
};

export const UpdateOneTrendsDevicesData = (orgGroups, selectedDate, selectedRef, selectedPeriod, selectedGroup, selectedDevice) => dispatch => {
  axios
    .get(
      API_ENDPOINTS.ANALYTICS_TRENDS.replace("{orgId}", selectedGroup.group_org_id)
        .replace("{groupId}", selectedGroup._id)
        .replace("{deviceId}", selectedDevice.device)
        .replace("{ref}", selectedRef.value)
        .replace("{period}", selectedPeriod.value)
        .replace("{date}", selectedDate)
    )
    .then(res => {
      let _groups = [];
      orgGroups.forEach(group => {
        let _devices = [];
        group.devices.forEach(device => {
          _devices.push(device.device === res.data.device ? { ...device, ...res.data, isFetchingData: false, isExpanded: true } : { ...device });
        });
        _groups.push({ ...group, devices: _devices });
      });

      dispatch({
        type: ACTIONS.TRENDS.UPDATE_ONE_TRENDS_DEVICES_DATA,
        payload: _groups
      });
    });
};

export const UpdateOneServiceSchedulingDevicesData = (
  orgGroups,
  selectedDate,
  selectedPeriod,
  selectedGroup,
  selectedDevice,
  selectedOrganization
) => dispatch => {
  // setOpenDevicesToReloadMode(orgGroups)
  axios
    .get(
      API_ENDPOINTS.ANALYTICS_SERVICE_SCHEDULES.replace("{orgId}", selectedOrganization._id)
        .replace("{groupId}", selectedGroup._id)
        .replace("{deviceId}", selectedDevice.device)
        .replace("{period}", selectedPeriod.value)
        .replace("{date}", selectedDate)
    )
    .then(res => {
      let _groups = [];
      orgGroups.forEach(group => {
        let _devices = [];
        group.devices.forEach(device => {
          _devices.push(device.device === res.data.device ? { ...device, ...res.data, isFetchingData: false, isExpanded: true } : { ...device });
        });
        _groups.push({ ...group, devices: _devices });
      });

      dispatch({
        type: ACTIONS.SERVICE_SCHEDULES.UPDATE_ONE_SERVICE_SCHEDULES_DEVICES_DATA,
        payload: _groups
      });
    })
    .catch(err => {
      console.warn("ERR", err);
    });
};

export const RemoveFromTrendsDevicesData = (orgGroups, selectedDevice) => dispatch => {
  let _groups = [];
  orgGroups.forEach(group => {
    let _devices = [];
    group.devices.forEach(device => {
      _devices.push(
        device.device === selectedDevice.device
          ? {
              ...selectedDevice,
              isFetchingData: true,
              data: [],
              refData: [],
              isExpanded: false
            }
          : { ...device }
      );
    });
    _groups.push({ ...group, devices: _devices });
  });
  dispatch({
    type: ACTIONS.TRENDS.REMOVE_FROM_TRENDS_DEVICES,
    payload: _groups
  });
};

export const ChangeDeviceDataIsExpanded = (orgGroups, deviceData, value) => dispatch => {
  let _groups = [];
  orgGroups.forEach(group => {
    let _devices = [];
    group.devices.forEach(device => {
      _devices.push(device.device === deviceData.device ? { ...deviceData, isExpanded: value } : { ...device });
    });
    _groups.push({ ...group, devices: _devices });
  });

  dispatch({
    type: ACTIONS.TRENDS.CHANGE_DEVICE_DATA_IS_EXPANDED,
    payload: _groups
  });
};
export const updateDevicesWithDetailsList = devicesWithDetailsList => dispatch => {
  dispatch({
    type: ACTIONS.TRENDS.UPDATE_DEVICES_WITH_DETAILS_LIST,
    payload: [...devicesWithDetailsList]
  });
};

export const SetNewThreshold = (orgGroups, selectedOrganization, serviceThresholdObj, selectedDevice) => dispatch => {
  return axios
    .put(API_ENDPOINTS.SERVICE_SCHEDULES_PUT_THRESHOLD.replace("{orgId}", selectedOrganization._id).replace("{deviceId}", selectedDevice._id), {
      ...serviceThresholdObj
    })
    .then(res => {
      let _groups = [];
      orgGroups.forEach(group => {
        let _devices = [];
        group.devices.forEach(device => {
          _devices.push(
            device.device === selectedDevice.device
              ? {
                  ...selectedDevice,
                  serviceSchedule: { ...res.data }
                }
              : { ...device }
          );
        });
        _groups.push({ ...group, devices: _devices });
      });
      dispatch({
        type: ACTIONS.SERVICE_SCHEDULES.UPDATE_DEVICE_THRESHOLD,
        payload: _groups
      });
      return { case: true, msg: "" };
    })
    .catch(err => ({ case: false, msg: err }));
};
export const RestDeviceService = (selectedOrganization, selectedDevice, orgGroups) => dispatch => {
  return axios
    .post(
      API_ENDPOINTS.RESET_SERVICE_SCHEDULES.replace("{orgId}", selectedOrganization._id)
        .replace("{deviceId}", selectedDevice._id)
        .replace("{serviceScheduleId}", selectedDevice.serviceSchedule._id)
    )
    .then(res => {
      let _groups = [];
      orgGroups.forEach(group => {
        let _devices = [];
        group.devices.forEach(device => {
          _devices.push(
            device.device === selectedDevice.device
              ? {
                  ...selectedDevice,
                  serviceSchedule: { ...res.data }
                }
              : { ...device }
          );
        });
        _groups.push({ ...group, devices: _devices });
      });
      dispatch({
        type: ACTIONS.SERVICE_SCHEDULES.RESET_SERVICE_SCHEDULES,
        payload: _groups
      });
      return { case: true, msg: "" };
    })
    .catch(err => ({ case: false, msg: err }));
};

export const SetSelectedDevicesList = selectedDevicesList => dispatch => {
  dispatch({
    type: ACTIONS.COMPARE.SET_SELECTED_DEVICES_LIST,
    payload: selectedDevicesList
  });
};

export const UpdateCompareSelectedDevicesListData = (selectedOption, selectedDate, selectedPeriod, selectedOrganization) => dispatch => {
  let _reqsList = [];

  dispatch({
    type: ACTIONS.COMPARE.FETCH_SELECTED_DEVICES_LIST_DATA,
    payload: true
  });

  selectedOption.forEach(device => {
    _reqsList.push(
      axios.get(
        API_ENDPOINTS.ANALYTICS_TRENDS.replace("{orgId}", selectedOrganization._id)
          .replace("{groupId}", "")
          .replace("{deviceId}", device.value.device)
          .replace("{ref}", "")
          .replace("{period}", selectedPeriod.value)
          .replace("{date}", selectedDate)
      )
    );
  });
  Promise.all([..._reqsList]).then(values => {
    let _values = [];
    values.forEach((value, vindex) => {
      _values.push({ ...value.data });
    });
    dispatch({
      type: ACTIONS.COMPARE.SET_SELECTED_DEVICES_LIST_DATA,
      payload: _values
    });
  });
};
